import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]

  connect() {
    // Modal is hidden by default
  }

  show() {
    this.element.classList.remove("hidden")
    this.element.classList.add("flex")
    document.body.style.overflow = "hidden"
  }

  close() {
    this.element.classList.add("hidden")
    this.element.classList.remove("flex")
    document.body.style.overflow = ""
  }

  closeOnBackdrop(event) {
    // Only close if clicking on the backdrop itself, not the modal content
    if (event.target === event.currentTarget || !this.contentTarget.contains(event.target)) {
      this.close()
    }
  }

  stopPropagation(event) {
    event.stopPropagation()
  }
}